<template>
  <router-view />
</template>

<style lang="scss">
.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #fc4353 !important;
  color: white !important;
}
.el-pagination.is-background .el-pager li:not(.disabled):hover {
    color:  #fc4353 !important;
}
// .el-pagination.is-background .btn-next,
// .el-pagination.is-background .btn-prev,
// .el-pagination.is-background .el-pager li {
//   margin: 0 5px;
//   background-color: #f4f4f5;
//   color: #fc4353 !important;
//   min-width: 30 px;
//   border-radius: 2 px;
// }

.warpper {
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #f7f7f7;
  .swiper-container {
    --swiper-theme-color: #ff6600; /* 设置Swiper风格 */
    --swiper-navigation-color: #333; /* 单独设置按钮颜色 */
    --swiper-navigation-size: 40px; /* 设置按钮大小 */
    outline: 1;
  }

  .swiper-button-lock {
    display: none;
  }

  .swiper-button-prev,
  .swiper-button-next {
    position: absolute;
    top: 50%;
    width: calc(var(--swiper-navigation-size) / 44 * 27);
    height: var(--swiper-navigation-size);
    margin-top: calc(0px - (var(--swiper-navigation-size) / 2));
    z-index: 10;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--swiper-navigation-color, var(--swiper-theme-color));
    &.swiper-button-disabled {
      opacity: 0.35;
      cursor: auto;
      pointer-events: none;
    }
    &:after {
      font-family: swiper-icons;
      font-size: 26px;
      text-transform: none !important;
      letter-spacing: 0;
      text-transform: none;
      font-variant: initial;
      line-height: 1;
    }
  }
  .swiper-button-prev,
  .swiper-container-rtl .swiper-button-next {
    &:after {
      content: "prev";
    }
    left: 10px;
    right: auto;
    background: #97959278;
    width: 50px;
    height: 50px;
    border-radius: 50%;
  }
  .swiper-button-next,
  .swiper-container-rtl .swiper-button-prev {
    &:after {
      content: "next";
    }
    right: 10px;
    left: auto;
    background: #97959278;
    width: 50px;
    height: 50px;
    border-radius: 50%;
  }

  .wrapper {
    display: flex;
    flex-direction: row;
    overflow-x: auto !important;
    height: 100%;
    width: 100%;
  }
  .swiper-container,
  .swiper-item {
    width: 100%;
    height: 100%;
  }
  .item {
    margin: 0 20px;
  }
  .swiper-img {
    width: 214px;
    height: 214px;
  }
  .swiper-button-prev {
    color: black;
  }
  .swiper-button-next {
    color: black;
  }
}
</style>
